import { useEffect } from 'react';
import { useFormContext } from '../contexts/FormContext';
import { logger } from '../utils/logger';

export const useFormAutoClose = (isSubmitting: boolean) => {
  const { closeForm } = useFormContext();

  useEffect(() => {
    const checkAndCloseIfContactExists = () => {
      try {
        // Don't auto-close if we're currently submitting
        if (isSubmitting) {
          return;
        }
        
        // Check for contact submission flag (non-PII timestamp only)
        const contactSubmittedAt = localStorage.getItem('contactSubmittedAt');
        
        // Only auto-close if contact was submitted recently (within last 5 minutes)
        if (contactSubmittedAt) {
          const submissionTime = parseInt(contactSubmittedAt);
          const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
          
          if (submissionTime > fiveMinutesAgo) {
            closeForm();
            return;
          } else {
            // Clear old timestamp
            localStorage.removeItem('contactSubmittedAt');
          }
        }
        
      } catch (error) {
        logger.error('🔍 FormAutoClose: Error checking localStorage:', error);
      }
    };
    
    checkAndCloseIfContactExists();
  }, [closeForm, isSubmitting]);

  return { closeForm };
};